module.exports = __webpack_public_path__ + "img/rluijten-2x_905e27c03ab55507d9725062169a9ade.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/rluijten-2x.jpg
// module id = 247
// module chunks = 0